function formatarValor(valor) {
    return valor.toLocaleString('pt-BR');
}

const installmentsAndPrices = () => {
    const frameInDesc = document.querySelector('.prod-page-video-container iframe')
    const videoSrc = wsMain.globalData.infoProduto.video

    if(videoSrc){
        frameInDesc.src = videoSrc.replace("https://youtu.be/", "https://www.youtube.com/embed/")
    } else {
        document.querySelector('.prod-page-video-container').style.display = 'none'
    }
    
    const price = document.querySelector('[data-wsjs-product="priceCash"]')
    
    if(price) {
        const installmentsContainer = document.querySelector('.prod-installments-container ul')

        const priceArr = price.innerHTML.split(' ')
        const priceInSpan = priceArr[0]
        price.innerHTML = `<span>${priceInSpan}</span> &agrave; vista no Pix ou Boleto`

        installmentsContainer.innerHTML += `<li>1x no Pix ou Boleto ${priceInSpan}</li>`
    }
    
    const installments = document.querySelectorAll('.prod-installments-container ul li')
    installments.forEach((li, i)=> {
        if(li.innerHTML.includes('1x de') && i == 0) {
            const value = li.innerHTML.split(' ')[2].replace('R$&nbsp;', '').replace('.', '').replace(',', '.')
            const discountValue = (Number(value) * 0.88).toFixed(2)
            const formatedValue = formatarValor(parseFloat(discountValue))
            li.innerHTML = `1x de R$&nbsp;${formatedValue} com 12% de desconto`
        }
    })
}

function treatElementsSpace(){
    const height = document.querySelector('.prod-infos-social-promo-container').clientHeight
    if(height === 0) document.querySelector('.prod-infos-social-promo-container').style.marginBottom = '0'
}

try {
    isReady('pag-produto', installmentsAndPrices)
} catch (error) {}


try {
    isReady('pag-produto', treatElementsSpace)
} catch (error) {}

